import { getDefaultMiddleware } from '@reduxjs/toolkit';
import { store } from '@stencil/redux';
import type { IModuleStore, IModuleTuple } from 'redux-dynamic-modules-core';
import { createStore } from 'redux-dynamic-modules-core';
import { EnvModule } from './env/env.module';
import { crashReporter } from './middlewares';
import { RequestModule } from './requests/requests.module';
import { requestSlice } from './requests/requests.slice';
import { UserModule } from './user/user.module';

export function initStore(initialState = {}, modules = []): void {
  if (store.getStore()) return;

  const OneModuleStore = createStore(
    {
      initialState,
      extensions: [{ middleware: [crashReporter, ...getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }), requestSlice.middleware] }],
    },
    ...EnvModule(),
    ...RequestModule(),
    ...UserModule(),
    ...modules,
  );
  store.setStore(OneModuleStore);
}

function getStore() {
  const oneStore = store.getStore();
  if (!oneStore) {
    console.error('ONE Components Store not initialized. Make sure the ONE Components package is loaded correctly.');
    return;
  }
  return oneStore;
}

export const addModules = (modules: IModuleTuple): any => {
  const store = getStore();
  if (!store) return;

  return (store as IModuleStore<any>).addModules(modules);
};

export const getState = (): any => {
  const store = getStore();
  if (!store) return;

  return store.getState();
};

export const dispatch = (action: any): any => {
  const store = getStore();
  if (!store) return;

  return store.dispatch(action);
};

export type OneStoreType = any;
